import { InsuredTripPartner } from "./insured-trip-partner";

export class InsuredTripDetail {
  policyNumber: string;
  groupPolicyNumber: string;
  dateBegin: string;
  dateEnd: string;
  premium: number;
  rate: number;
  statusId: number;
  statusLabel: string;
  scheme: string;
  zone: string;
  groupDateBegin: string;
  groupDateEnd: string;
  tariff: string;
  partner: InsuredTripPartner
}
